export * from './src/data-v2-index-indexes.meta.js';
